export default {
	data() {
		return {
			dayStart: 0, //hrs from 00:00
			dayLength: 24,
			scheduleIncrement: 0.5, //hrs
			/*
			activeItemIndex: null,
			activeRowIndex: null,
			activeRowId: null,
			*/
			activeEventId: null,
			grabbedActiveEventId: null,//
			eventTotals: {
				numSickDaysUsed: false,
				numVacationUsed: false,
				numVacationScheduled: false,
				partialSickDayHrsUsed: false,
				numPartialSickDays: false
			},
			conflictResolutionModal: {
				visible: false,
				conflictEventId: null,
				message: null,
				newEventPayload: null,
				conflictEvent: null
			},
			duplicateConfirmModal: {
				working: false,
				visible: false,
				relatedJobEvents: [],
				eventPayload: {}
			},
			filters: { 
				mainTypes: ["project","service"],
				projectIds: [],
				serviceIds: [],
				equipmentIds: [],
				userIds: [],
				showOnlyRelated: false,
				mineOnly: false,
				jobCategories: [],
				showActiveParentsChildren: true //whether to show active parent's child events
			},
			users: [],
			employeeSearchTerms: ""
		}
	},
	watch: {
		'$store.categories'() {
			//this.filters.jobCategories = this.$store.categories.map(cat => cat.id)
		}
	},
	computed: {
		resetDate() {
			let thisYear = this.moment().format("YYYY")

			let resetDate = this.moment().startOf("year")

			if (this.$store.company && "CompanySetting" in this.$store.company)
				resetDate = this.moment.utc(thisYear+"-"+this.$store.company.CompanySetting.vacation_reset_month+"-"+this.$store.company.CompanySetting.vacation_reset_day)

			if (resetDate.isAfter(this.moment.utc()))
				resetDate = resetDate.subtract(1,"y")

			return resetDate
		},
		scheduleSettings() {
			if ("CompanySetting" in this.$store.company && this.$store.company.CompanySetting) {
				try {
					return JSON.parse(this.$store.company.CompanySetting.schedule_defaults_json)
				}
				catch (e) {}
			}
			return {}
		},
		startOfWeekMoment() {
			return this.moment(this.selectedDate).startOf("week")
		},
		week() {
			let days = []

			for (var i = 0; i < 7; i++) {
				let nextDay = this.moment(this.startOfWeekMoment).add(i,"days")
				days.push(nextDay)			
			}

			return days
		},
		employeePickerMutatedUsers() {
			let vm = this

			let filteredUsers = this.users

			if (this.employeeSearchTerms) {

				let lowerCaseTerms = this.employeeSearchTerms.toLowerCase()

				filteredUsers = filteredUsers.filter(user => {
					if (user.first_name.toLowerCase().indexOf(lowerCaseTerms) >= 0)
						return true
					else if (user.last_name.toLowerCase().indexOf(lowerCaseTerms) >= 0)
						return true

					return false
				})
			}

			if (this.employeeListFilters.indexOf("hide-salaried-employees") >= 0)  
				filteredUsers = filteredUsers.filter(user => !("EmployeeSetting" in user) || !user.EmployeeSetting || user.EmployeeSetting.length == 0 || user.EmployeeSetting[0].is_salary == 0)

			if (this.employeeListFilters.indexOf("only-unscheduled") >= 0) 
				filteredUsers = filteredUsers.filter(user => this.calcHoursScheduled(this.$store.scheduleEvents,user,'user_id') == 0)

			return filteredUsers.map(user => {
				user.description = user.first_name+" "+user.last_name
				user.type = "user"

				let userEvents = vm.$store.scheduleEvents.filter(event => event.user_id == user.id)
				let userEventsAppended = userEvents.reduce((acc,event) => {
						let eventString = ""
						if (event.Service)
							eventString += "Service #"+event.Service.job_num
						else if (event.Job)
							eventString += "Project #"+event.Job.job_num
						else if (event.is_vacation == 1)
							eventString += "Vacation"
						else if (event.is_sickday == 1)
							eventString += "Medical Leave"
						else
							eventString += "Other Event"

						eventString += " "+vm.moment(event.start_time).format("HH:mm A")+" to "+vm.moment(event.end_time).format("HH:mm A")

						return acc + eventString+"\n"
					},"")

				user.tooltip = "Schedule events:\n"+userEventsAppended

				let selectedDateStartMomentUTC = vm.moment(vm.selectedDate + " 00:00").utc()
				let selectedDateEndMomentUTC = vm.moment(vm.selectedDate + " 23:59").utc()

				user.isOnVacation = false
				user.isScheduledOff = false
				user.isSick = false

				let fullDayUserEvents = userEvents.filter(event => vm.moment.utc(event.start_time).isSameOrBefore(selectedDateStartMomentUTC) && vm.moment.utc(event.end_time).isSameOrAfter(selectedDateEndMomentUTC))

				if (fullDayUserEvents.length > 0) {
					user.isOnVacation = fullDayUserEvents.find(event => event.is_vacation == 1) ? true : false
					user.isScheduledOff = fullDayUserEvents.find(event => event.is_off == 1) ? true : false
					user.isSick = fullDayUserEvents.find(event => event.is_sickday == 1) ? true : false
				}

				user.scheduledHours = vm.calcHoursScheduled(vm.$store.scheduleEvents,user,'user_id',vm.selectedDate)

				return user
			})
		}
	},
	methods: {
		eventsOverlap(event1StartMoment,event1EndMoment,event2StartMoment,event2EndMoment) {
			if (event1StartMoment.isBefore(event2StartMoment) && event1EndMoment.isAfter(event2StartMoment)) {
				/*
				console.log("PARTIALLY OVERLAPPED: start 1 is before start 2 and end 1 is after start 2", 
					event1StartMoment.format("YYYY-MM-DD HH:MM"), 
					event1EndMoment.format("YYYY-MM-DD HH:MM"), 
					event2StartMoment.format("YYYY-MM-DD HH:MM"), 
					event2EndMoment.format("YYYY-MM-DD HH:MM")
				)
				*/
				return true
			}

			if (event1StartMoment.isBefore(event2StartMoment) && event1EndMoment.isAfter(event2EndMoment)) {
				//console.log("CONTAINING EVENT 2: start 1 is after start 2 and end 1 is after end 2")
				return true
			}

			if (event1StartMoment.isAfter(event2StartMoment) && event1StartMoment.isBefore(event2EndMoment)) {
				//console.log("PARTIALLY OVERLAPPED: start 1 is after start 2 and start 1 is before end 2")
				return true
			}

			if (event1StartMoment.isAfter(event2StartMoment) && event1EndMoment.isBefore(event2EndMoment)) {
				//console.log("CONTAINING EVENT 1: start 1 is after start 2 and start 1 is before end 2")
				return true
			}

			return false
		},
		initFilters() {
			this.initTypeFilterValues()

			if (this.projectId) {
				this.filters.projectIds = [this.projectId]
				this.filters.mainTypes = ["project","equipment","user"]
				this.projectFiltering = true
				//this.filters.showOnlyRelated = true
			}

			if (this.serviceId) {
				/*
				this.filters.serviceIds = [this.serviceId]
				this.serviceFiltering = true
				*/
				this.filters.mainTypes = ["service","equipment","user"]
				
				//this.filters.showOnlyRelated = true
			}

			this.filters.jobCategories = [] //default to empty to show all //this.$store.categories.map(cat => cat.id)

			if (this.filtersExternal) {
				this.filters = this.filtersExternal

				if (this.filters.serviceIds.length > 0)
					this.serviceFiltering = true

				if (this.filters.projectIds.length > 0)
					this.projectFiltering = true

				if (this.filters.equipmentIds.length > 0)
					this.equipmentFiltering = true

				if (this.filters.userIds.length > 0)
					this.userFiltering = true
			}

			if (this.filters.mainTypes.length > 0) 
				this.typeFiltering = true

			if (!this.hasModulePermRead("Schedule")) {
				this.filters.mineOnly = true
				this.fetchMyJobs()
			}
		},
		calcScheduleEventTypeTotals(events) {
			let vm = this

			let lessRejectedEvents = events.filter(event => event.rejected_by == 0).map(event => {
					event.durationHrs = vm.moment(event.end_time).diff(vm.moment(event.start_time),'hours')
					return event
				})

			let numSickDaysUsed = lessRejectedEvents
				.filter(event => {
					let durationHrs = this.moment(event.end_time).diff(this.moment(event.start_time),"hours")

					return event.is_sickday == 1 && (durationHrs == 0 || durationHrs > 8)
				})
				.reduce((acc,event) => {
					if (event.end_time) {
						let startTruncated = vm.moment(event.start_time).format("YYYY-MM-DD")
						let days = vm.moment(event.end_time).diff(vm.moment(startTruncated),'days')

						return acc+days
					}
					else
						return acc+1
				},0)



			let partialSickDayHrsUsed = lessRejectedEvents
				.filter(event => event.is_sickday == 1 && event.durationHrs > 0 && event.durationHrs < 8)
				.reduce((acc,event) => acc+ +event.durationHrs,0)
			
			let numPartialSickDays = lessRejectedEvents.filter(event => event.is_sickday == 1 && event.durationHrs > 0 && event.durationHrs < 8).reduce((acc,event) => acc + 1,0)

			let numVacationUsed = lessRejectedEvents.filter(event => this.moment(event.start_time).isBefore() && event.is_vacation == 1).reduce((acc,event) => {
				if (event.end_time) {
					let days = vm.moment(event.end_time).diff(vm.moment(event.start_time),'days')
					return acc+days+1
				}
				else
					return acc+1
			},0)
			
			let numVacationScheduled = lessRejectedEvents.filter(event => this.moment(event.start_time).isSameOrAfter() && event.is_vacation == 1).reduce((acc,event) => {
				if (event.end_time) {
					let days = vm.moment(event.end_time).diff(vm.moment(event.start_time),'days')
					return acc+days+1
				}
				else
					return acc+1
			},0)

			return {
				numSickDaysUsed,
				partialSickDayHrsUsed,
				numPartialSickDays,
				numVacationUsed,
				numVacationScheduled
			}
		},
		approveRejectVacation(event_id,approve) {
			let vm = this

			return new Promise((resolve,reject) => {

				//get event first
				vm.getJSON("ScheduleEvent/find/"+event_id,{},true).then(response => {
					if (response.success) {

						let payload = {
							user_id: response.data.user_id,
							id: event_id,
						}
						if (approve)
							payload.approved = 1
						else
							payload.approved = 0

						vm.postData("ScheduleEvent/vacation-approval",payload,true).then(postResponse => {
							if (postResponse.success) {
								if (approve)
									vm.alertSuccess("Vacation time approved")
								else
									vm.alertSuccess('Vacation time rejected. The user has been notified.')
							}
							resolve(postResponse)
						})
					}
					else
						resolve({
							success: false,
							error: "Event not found"
						})
				})
			})
		},
		deepCloneEventObj(obj) {
			if (obj) {
				if ("startMoment" in obj) {
					if (typeof obj.startMoment == 'object') 
						obj.startDateTimeString = obj.startMoment.format("YYYY-MM-DD HH:mm")
					else
						obj.startDateTimeString = obj.startMoment
					
					delete obj.startMoment
				}
				
				if ("endMoment" in obj) {
					if (typeof obj.endMoment == 'object') 
						obj.endDateTimeString = obj.endMoment.format("YYYY-MM-DD HH:mm")
					else
						obj.endDateTimeString = obj.endMoment
					
					delete obj.endMoment
				}
			
				let cloned = JSON.parse(JSON.stringify(obj))

				if ("startDateTimeString" in cloned) {
					cloned.startMoment = this.moment(cloned.startDateTimeString)
					delete cloned.startDateTimeString
				}
				
				if ("endDateTimeString" in cloned) {
					cloned.endMoment = this.moment(cloned.endDateTimeString)
					delete cloned.endDateTimeString
				}

				return cloned
			}
			else
				return obj
		},
		calcHoursScheduled(events,entity,entity_key,selectedDate = false) {
			let vm = this

			let hours = events
				.filter(event => event[entity_key] == entity.id && event.is_vacation == 0 && event.is_sickday == 0 && event.is_off == 0)
				.filter(event => !selectedDate || selectedDate == vm.moment.utc(event.start_time).local().format("YYYY-MM-DD"))
				.filter(event => 
					((entity.type == 'project' || entity.type == 'service') && event.user_id == 0 && event.equipment_id == 0) ||
					(entity.type == 'user' && event.user_id > 0) || 
					(entity.type == 'equipment' && event.equipment_id > 0)
				)
				.reduce((acc,event) => acc + vm.moment.utc(event.end_time).local().diff(vm.moment.utc(event.start_time).local(),"hours"),0)

			return hours.round(1)
		},
		typeIcon(type) {
			if (type == "user")
				return "fa-user"
			if (type == "equipment" || type == 'equipment-servicing')
				return "fa-truck"
			if (type == "project")
				return "fa-cube"
			if (type == "service")
				return "fa-wrench"
		},
		rowIsParent(row) {
			if (row.type == 'project' || row.type == 'service')
				return true

			return false
		},
		calcIndexFromMoment(date,selectedDate) {
			let hour = this.dayStart
			if (hour < 10)
				hour = "0"+hour

			let hoursFromDayStart = this.moment(date).diff(this.moment(selectedDate+" "+hour+":00"),"minutes")/60

			return hoursFromDayStart / this.scheduleIncrement
		},
		renderEventObj(event) {
			//mutates an event into an object usable by the schedule

			let eventType, eventEntityKey, description, vm = this
			if (event.user_id > 0 && "User" in event) {
				eventType = 'user'
				eventEntityKey = "user_id"
				description = event.User.first_name+" "+event.User.last_name
			}
			else if (event.equipment_id > 0 && "Equipment" in event) {
				eventType = 'equipment'
				eventEntityKey = "equipment_id"

				if (!event.Equipment)
					description = "Equipment item (deleted)"
				else
					description = event.Equipment.description
			}
			else if (event.job_id > 0 && "Job" in event) {
				eventType = 'project'
				eventEntityKey = "job_id"
				description = event.Job.job_num+": "+event.Job.job_name
			}
			else if (event.service_id > 0 && "Service" in event) {
				eventType = 'service'
				eventEntityKey = "service_id"
				description = event.Service.job_num+": "+event.Service.job_name
			}

			let durationMins = vm.moment(event.end_time).diff(event.start_time,"minutes")

			let durationHrs = durationMins / 60

			let startMoment = vm.moment.utc(event.start_time).local()
			let endMoment = vm.moment.utc(event.end_time).local()

			let attachedJobDescription = ""
			if (eventType == 'user' || eventType == 'equipment') {
				if ("Service" in event && event.Service)
					attachedJobDescription = "Service #"+event.Service.job_num+": "+event.Service.job_name
				else if ("Job" in event && event.Job)
					attachedJobDescription = "Project #"+event.Job.job_num+": "+event.Job.job_name
			}

			let obj = {
				type: eventType,
				entityKey: eventEntityKey,
				id: event.id,
				startMoment,
				endMoment,
				duration: durationHrs,
				description,
				attachedJobDescription,
				shortDescription: vm.shortenDescription(description,durationHrs / vm.scheduleIncrement),
				isVacation: event.is_vacation,
				isSickday: event.is_sickday,
				is_published: event.is_published,
				is_off: event.is_off,
				lead_technician_id: event.lead_technician_id,
				userRole: false,
				notes: event.notes,
				starting_location: event.starting_location,
				title: event.title
			}

			let attached = ["Service","Job","User","ApprovedBy","RejectedBy","Equipment","user_id","equipment_id","service_id","job_id","repeat_until","is_vacation","is_sickday","priority_index","isLeadTechnician"]
			attached.forEach(key => {
				if (key in event)
					obj[key] = event[key]
			})

			//add a label for personnel role if this is a user event attached to a job and the user has a role on it
			if (eventType == 'user') {

				let jobkey = false
				if ("Job" in obj && obj.Job) 
					jobkey = "Job"
				else if ("Service" in obj && obj.Service)
					jobkey = "Service"
				
				if (jobkey && "JobPersonnelRole" in obj[jobkey] && obj[jobkey].JobPersonnelRole) 
					//check if user is assigned to one of these roles
					obj.userRole = obj[jobkey].JobPersonnelRole.find(role => role.user_id == obj.User.id)	
				
			}

			return obj
		},
		renderEquipmentObj(eq) {
			let vm = this
			let startMoment = vm.moment(eq.next_service_date+" 00:00")

			let duration = 24

			let description = "Servicing: "+eq.description+": "+eq.next_service_description
			
			let obj = {
				type: 'equipment-servicing',
				id: eq.id,
				equipmentSlug: eq.slug,
				startMoment,
				endMoment: vm.moment(eq.next_service_date).endOf("day"),
				duration,
				startIndex: vm.calcIndexFromMoment(startMoment,this.selectedDate),
				description,
				shortDescription: vm.shortenDescription(description,duration / vm.scheduleIncrement)
			}

			return obj
		},
		sortEventsToEntityTypesAndPriority(events) {
			// Render the events if needed.
			const renderedEvents = events.map(event => this.renderEventObj(event));

			// Separate the events by type.
			const projects = renderedEvents.filter(event => event.type === 'project');
			const services = renderedEvents.filter(event => event.type === 'service');
			const users = renderedEvents.filter(event => event.type === 'user');
			const equipment = renderedEvents.filter(event => event.type === 'equipment');

			// Sort the parent events by priority_index.
			projects.sort((a, b) => a.priority_index - b.priority_index);
			services.sort((a, b) => a.priority_index - b.priority_index);

			// Sort the child events alphabetically by description.
			users.sort((a, b) => a.description.localeCompare(b.description));
			equipment.sort((a, b) => a.description.localeCompare(b.description));

			const sortedEvents = [];

			// Process projects: add each project and then attach its child events.
			projects.forEach(project => {
			// Push the parent project event.
				sortedEvents.push(project);

				// For projects, we expect the children to have a 'job_id' field.
				const projectChildUsers = users.filter(user => user.job_id === project.job_id && user.startMoment.isSame(project.startMoment,'day'));
				const projectChildEquipment = equipment.filter(eq => eq.job_id === project.job_id && eq.startMoment.isSame(project.startMoment,'day'));

				// Optionally annotate child events to indicate their related project.
				projectChildUsers.forEach(child => {
					child.relatedProjectId = project.job_id;
				});
				projectChildEquipment.forEach(child => {
					child.relatedProjectId = project.job_id;
				});

				// Attach the child events immediately after the parent.
				sortedEvents.push(...projectChildUsers, ...projectChildEquipment);
			});

			// Process services: add each service and then attach its child events.
			services.forEach(service => {
				// Push the parent service event.
				sortedEvents.push(service);

				// For services, we expect the children to have a 'service_id' field.
				const serviceChildUsers = users.filter(user => user.service_id === service.service_id && user.startMoment.isSame(service.startMoment,'day'));
				const serviceChildEquipment = equipment.filter(eq => eq.service_id === service.service_id && eq.startMoment.isSame(service.startMoment,'day'));

				// Optionally annotate child events to indicate their related service.
				serviceChildUsers.forEach(child => {
					child.relatedProjectId = service.service_id;
				});
				serviceChildEquipment.forEach(child => {
				 	child.relatedProjectId = service.service_id;
				});

				// Attach the child events immediately after the parent.
				sortedEvents.push(...serviceChildUsers, ...serviceChildEquipment);
			});

			return sortedEvents;
		},
		sortEventRowsToEntityTypes(rows) {
			//sort into entity types first
			let users = rows.filter(row => row.type == 'user')
			let equipment = rows.filter(row => row.type == 'equipment')
			let projects = rows.filter(row => row.type == 'project')
			let services = rows.filter(row => row.type == 'service')
			let eqServicing = rows.filter(row => row.type == 'equipment-servicing')

			let sorted = []
			projects.sort((a,b) => {
				if (a.items[0].Job.job_num > b.items[0].Job.job_num)
					return 1
				return -1
			})
			services.sort((a,b) => {
				if (a.items[0].Service.job_num > b.items[0].Service.job_num)
					return 1
				return -1
			})
			users.sort((a,b) => {
				if (a.description.toUpperCase() > b.description.toUpperCase())
					return 1
				return -1
			})
			equipment.sort((a,b) => {
				if (a.description > b.description)
					return 1
				return - 1
			})

			return {
				projects,
				services,
				users,
				equipment,
				eqServicing
			}
		},
		renderScheduleRows(events,equipmentServicing) {
			let rows = [], vm = this, rowId = 1

			if (events) {
				events.forEach(event => {
					let obj = vm.renderEventObj(event)

					obj.startIndex = vm.calcIndexFromMoment(obj.startMoment,this.selectedDate)

					let color_hex = ""
					if (obj.type == 'user' && obj.User && obj.User.EmployeeSetting && obj.User.EmployeeSetting.length > 0)
						color_hex = obj.User.EmployeeSetting[0].color_hex 

					//find matching row
					/*
					let matchIndex = rows.findIndex(row => row.type == obj.type && row.entity_id == event[obj.entityKey])

					if (matchIndex >= 0) {
						//add to items
						rows[matchIndex].items.push(obj)
					}
					else {
						*/
						rows.push({
							type: obj.type,
							entity_id: event[obj.entityKey],
							entityKey: obj.entityKey,
							items: [obj],
							description: obj.description,
							color_hex,
							rowId
						})
						rowId++
					//}
				})
			}

			if (equipmentServicing) {
				equipmentServicing.forEach(eq => {

					let obj = vm.renderEquipmentObj(eq)

					rows.push({
						type: "equipment-servicing",
						entity_id: eq.id,
						entityKey: "equipment_id",
						description: obj.description,
						items: [obj],
						rowId
					})

					rowId++
				})
			}

			/*
				Should be sorted by:
				Project
					Users
					Equipment
				Service
					Users
					Equipment
				User Events
				Equipment Events
			*/
			//sort into entity types first
			let sorted = []
			let {projects,services,users,equipment,eqServicing} = this.sortEventRowsToEntityTypes(rows)

			//sort projects by priority order index
			projects = projects.sort((a,b) => {
				if (a.priority_index > b.priority_index)
					return 1
				else
					return -1
			})

			projects.forEach(projectEvent => {
				sorted.push(projectEvent)

				//find all users attached to this project
				users
					.filter(userRow => {
						//has this job on them
						return userRow.items.find(item => "job_id" in item && item.job_id == projectEvent.entity_id)
					})
					.map(userRow => {
						userRow.relatedProjectId = projectEvent.entity_id

						userRow.items = userRow.items.filter(item => item.job_id == projectEvent.entity_id).map(item => vm.deepCloneEventObj(item))

						return userRow
					})
					.forEach(userRow => {

						let clonedRow = JSON.parse(JSON.stringify(userRow)), clonedRowItems = []

						clonedRow.items.forEach(item => {
							clonedRowItems.push(vm.deepCloneEventObj(item))
						})

						clonedRow.items = clonedRowItems

						sorted.push(clonedRow)
					})

				//find all equipment attached to this project
				equipment
					.filter(eqEvent =>  eqEvent.items.find(item => "job_id" in item && item.job_id == projectEvent.entity_id))
					.map(eqEvent => {
						eqEvent.relatedProjectId = projectEvent.entity_id

						eqEvent.items = eqEvent.items.filter(item => item.job_id == projectEvent.entity_id).map(item => vm.deepCloneEventObj(item))

						return eqEvent
					})
					.forEach(eqEvent => {

						let clonedRow = JSON.parse(JSON.stringify(eqEvent)), clonedRowItems = []

						clonedRow.items.forEach(item => {
							clonedRowItems.push(vm.deepCloneEventObj(item))
						})

						clonedRow.items = clonedRowItems

						sorted.push(clonedRow)
					})
			})

			//sort projects by priority order index
			services = services.sort((a,b) => {
				if (a && "items" in a && a.items.length > 0 && b && "items" in b && b.items.length > 0 &&  a.items[0].priority_index > b.items[0].priority_index)
					return 1
				else
					return -1
			})

			//next come the services with all their stuff
			services.forEach(serviceEvent => {
				sorted.push(serviceEvent)

				//find all users attached to this project
				users
					.filter(userRow => userRow.items.find(item => "service_id" in item && item.service_id == serviceEvent.entity_id))
					.map(userRow => {
						userRow.relatedServiceId = serviceEvent.entity_id

						userRow.items = userRow.items.filter(item => item.service_id == serviceEvent.entity_id).map(item => vm.deepCloneEventObj(item))

						return userRow
					})
					.forEach(userRow => {

						let clonedRow = JSON.parse(JSON.stringify(userRow)), clonedRowItems = []

						clonedRow.items.forEach(item => {
							clonedRowItems.push(vm.deepCloneEventObj(item))
						})

						clonedRow.items = clonedRowItems

						sorted.push(clonedRow)
					})

				//find all equipment attached to this project
				equipment
					.filter(eqEvent => eqEvent.items.find(item => "service_id" in item && item.service_id == serviceEvent.entity_id))
					.map(eqEvent => {
						eqEvent.relatedServiceId = serviceEvent.entity_id

						eqEvent.items = eqEvent.items.filter(item => item.service_id == serviceEvent.entity_id).map(item => vm.deepCloneEventObj(item))

						return eqEvent
					})
					.forEach(eqEvent => {

						let clonedRow = JSON.parse(JSON.stringify(eqEvent)), clonedRowItems = []

						clonedRow.items.forEach(item => {
							clonedRowItems.push(vm.deepCloneEventObj(item))
						})

						clonedRow.items = clonedRowItems

						sorted.push(clonedRow)
					})
			})

			//next is the equipment servicings
			sorted = [
				...sorted,
				...eqServicing
			]

			//all the standalone user events
			sorted = [
				...sorted,
				...users.filter(userRow => {
					//show user here if user has any events that aren't attached to jobs
					return userRow.items.find(item => item.job_id == 0 && item.service_id == 0)
				})
				.map(userRow => {
					userRow.isStandalone = true
					return userRow
				})
			]

			//all the standalone equipment events
			sorted = [
				...sorted,
				...equipment.filter(eqRow => {
					//show equipment event here if eq has any events that aren't attached to jobs
					return eqRow.items.find(item => item.job_id == 0 && item.service_id == 0)
				})
				.map(eqRow => {
					eqRow.isStandalone = true
					return eqRow
				})
			]

			//now go through the entire list again, and flag the events that aren't related to the jobs they are listed underneath
			//this is so that we can "gray" out time slots that are taken up by an event elsewhere
			/*
			let theJobId, theJobKey
			sorted = sorted.map(row => {

				if (row.type == 'project' || row.type == 'service') {
					theJobId = row.entity_id
					theJobKey = row.entityKey
				}
				else {
					if ("relatedProjectId" in row && !row.relatedProjectId && "relatedServiceId" in row && !row.relatedServiceId) 
						theJobId = null

					row.items = row.items.map(item => {

						if ((!("isStandalone" in row) || !row.isStandalone) && item[theJobKey] != theJobId) {

							if ("relatedServiceId" in row && row.relatedServiceId && vm.filters.mainTypes.indexOf("service") >= 0)
								item.itemUnrelatedToParent = true
							else if ("relatedProjectId" in row && row.relatedProjectId && vm.filters.mainTypes.indexOf("project") >= 0)
								item.itemUnrelatedToParent = true
							else 
								item.itemUnrelatedToParent = false
						}
						else if ("isStandalone" in row && row.isStandalone) {
							if (item.service_id > 0 || item.job_id > 0)
								item.itemUnrelatedToParent = true
							else
								item.itemUnrelatedToParent = false
						}
						else
							item.itemUnrelatedToParent = false

						return item
					})
				}

				return row
			})
			*/

			return sorted
		},
		filterScheduleEvents(events) {
			let vm = this
			let projectsUserIsOn = [], servicesUserIsOn = []

			if (vm.filters.mineOnly) {
				events
					.filter(event => 
						event.type == "user" && 
						event[event.entityKey] == vm.$store.userDetails.id)
					.forEach(event =>  {
						if (event.job_id > 0)
							projectsUserIsOn.push(event.job_id)
					})

				events
					.filter(event => 
						event.type == "user" && 
						event[event.entityKey] == vm.$store.userDetails.id)
					.forEach(event =>  {
						if (event.service_id > 0)
							servicesUserIsOn.push(event.service_id)
					})
			}

			let filtered = events.filter((event,index) => {

				let include = true

				if (vm.filters.mainTypes.indexOf(event.type) == -1)
					include = false

				if (event.type == 'project' && vm.projectFiltering && vm.filters.projectIds.length > 0)
					include = vm.filters.projectIds.find(id => id == event[event.entityKey])

				if (event.type == 'service' && vm.serviceFiltering && vm.filters.serviceIds.length > 0) 
					include = vm.filters.serviceIds.find(id => id == event[event.entityKey])

				if (event.type == 'user' && vm.userFiltering && vm.filters.userIds.length > 0)  
					include = vm.filters.userIds.find(id => id == event[event.entityKey])

				if (vm.filters.mineOnly && include) {

					if (event.type == 'equipment-servicing')
						return false
					else if (event.type == 'user' && event[event.entityKey] == vm.$store.userDetails.id)
						return true

					//if event is a project, check $store.userProjectIds (jobs user has role on)
					if (event.type == 'project')
						include = vm.$store.userProjectIds.find(jobId => event[event.entityKey] == jobId)
					else if (event.type == 'service')
						include = vm.$store.userServiceIds.find(jobId => event[event.entityKey] == jobId)

					//check jobs user is scheduled on
					if (event.type == 'project') {
						include = projectsUserIsOn.find(jobId => event[event.entityKey] == jobId)
					}
					else if (event.type == 'service') {
						include = servicesUserIsOn.find(jobId => event[event.entityKey] == jobId)
					}
				}

				if (vm.filters.showOnlyRelated) {
					if (vm.serviceFiltering && (event.type == 'user' || event.type == 'equipment')) {
						//only include if this event is related to events in the services list
						include = vm.filters.serviceIds.indexOf(event.service_id) >= 0 ? true : false
					}

					if (vm.projectFiltering & (event.type == 'user' || event.type == 'equipment')) {
						//only incldue if the this event is related to the events in the projects list
						include = vm.filters.projectIds.indexOf(event.job_id) >= 0 ? true : false
					}
				}

				if (include && vm.filters.jobCategories.length > 0) {
					if (event.type != 'employee' && event.type != 'equipment') {
						//only include if it has events with a category that matches one in the selected category filters
						
						let job = null
						if ("Job" in event && event.Job)
							job = event.Job
						else if ("Service" in event && event.Service)
							job = event.Service

						if (job)
							if (vm.filters.jobCategories.indexOf(job.category_id) >= 0)
								include = true
						
					}
				}

				return include
			})
			return filtered
		},
		filterRenderedScheduleRows(rows) {
			let vm = this, activeRowEntityId = null

			//we need to get the current active rowId so we can remember it, and then use it
			//to reset the activeRowIndex, since that may change after the filtering
			 
			//let activeRow = rows.find(row => row.rowId == this.activeRowId)

			let activeRow = rows.find(row => {
				let item = row.items.find(item => item.id == vm.activeEventId)

				if (item)
					return true
			})

			let activeRowRelatedProjectId, activeRowRelatedServiceId

			if (activeRow)
				activeRowEntityId = activeRow.entity_id
			
			if (!rows)
				return []

			let projectsUserIsOn = [], servicesUserIsOn = []

			if (vm.filters.mineOnly) {
				rows
					.filter(row => 
						row.type == "user" && 
						row.entity_id == vm.$store.userDetails.id && 
						row.relatedProjectId)
					.forEach(row =>  {
						row.items.forEach(item => {
							if (item.job_id > 0)
								projectsUserIsOn.push(item.job_id)
						})
					})

				rows
					.filter(row => 
						row.type == "user" && 
						row.entity_id == vm.$store.userDetails.id && 
						row.relatedServiceId)
					.forEach(row =>  {
						row.items.forEach(item => {
							if (item.service_id > 0)
								servicesUserIsOn.push(item.service_id)
						})
					})
			}

			let filtered = rows.filter((row,index) => {

				let include = true

				if (vm.filters.mainTypes.indexOf(row.type) == -1)
					include = false

				if (row.type == 'project' && vm.projectFiltering && vm.filters.projectIds.length > 0)
					include = vm.filters.projectIds.find(id => id == row.entity_id)

				if (row.type == 'service' && vm.serviceFiltering && vm.filters.serviceIds.length > 0) 
					include = vm.filters.serviceIds.find(id => id == row.entity_id)

				if (row.type == 'user' && vm.userFiltering && vm.filters.userIds.length > 0)  
					include = vm.filters.userIds.find(id => id == row.entity_id)

				if (vm.filters.mineOnly && include) {

					if (row.type == 'equipment-servicing')
						return false
					else if (row.type == 'user' && row.entity_id == vm.$store.userDetails.id)
						return true

					//if row is a project, check $store.userProjectIds (jobs user has role on)
					if (row.type == 'project')
						include = vm.$store.userProjectIds.find(jobId => row.entity_id == jobId)
					else if (row.type == 'service')
						include = vm.$store.userServiceIds.find(jobId => row.entity_id == jobId)
					else if (row.relatedProjectId || row.relatedServiceId) {
						let hasRelatedJobItems = row.items.find(item => vm.$store.userProjectIds.indexOf(item.job_id) >= 0 || vm.$store.userServiceIds.indexOf(item.service_id) >= 0)

						if (!hasRelatedJobItems)
							include = false
					}

					//check jobs user is scheduled on
					if (row.type == 'project') {
						include = projectsUserIsOn.find(jobId => row.entity_id == jobId)
					}
					else if (row.type == 'service') {
						include = servicesUserIsOn.find(jobId => row.entity_id == jobId)
					}
					else if (row.relatedProjectId || row.relatedServiceId) {
						let hasRelatedJobItems = row.items.find(item => projectsUserIsOn.indexOf(item.job_id) >= 0 || servicesUserIsOn.indexOf(item.service_id) >= 0)

						if (!hasRelatedJobItems)
							include = false
					}
				}

				if (vm.filters.showOnlyRelated) {
					if (vm.serviceFiltering && (row.type == 'user' || row.type == 'equipment')) {
						//only include if this event is related to events in the services list
						include = row.items.find(item => vm.filters.serviceIds.indexOf(item.service_id) >= 0)
					}

					if (vm.projectFiltering & (row.type == 'user' || row.type == 'equipment')) {
						//only incldue if the this event is related to the events in the projects list
						include = row.items.find(item => vm.filters.projectIds.indexOf(item.job_id) >= 0)
					}

					if (row.items.length == 0)
						include = false
				}

				if (include && vm.filters.jobCategories && vm.filters.jobCategories.length > 0) {
					if (row.type != 'user' && row.type != 'equipment') {
						//only include if it has events with a category that matches one in the selected category filters
						include = row.items.find(item => {
							let job = null
							if ("Job" in item && item.Job)
								job = item.Job
							else if ("Service" in item && item.Service)
								job = item.Service

							if (job) {
							
								if (vm.filters.jobCategories.indexOf(job.category_id) >= 0 || ("ServiceContract" in job && job.ServiceContract) && vm.filters.jobCategories.indexOf(job.ServiceContract.category_id) >= 0)
									return true
							}
						})

						if (include)
							include = true
					}
				}

				if ("relatedProjectId" in row && row.relatedProjectId > 0 && activeRowEntityId == row.relatedProjectId)
					include = true
				if ("relatedServiceId" in row && row.relatedServiceId > 0 && activeRowEntityId == row.relatedServiceId)
					include = true

				//if active event is a child, make sure to show siblings because the parent needs to stay "opened"
				if (activeRow) {
					if ("relatedServiceId" in activeRow && "relatedServiceId" in row && activeRow.relatedServiceId == row.relatedServiceId)
						include = true
					if ("relatedProjectId" in activeRow && "relatedProjectId" in row && activeRow.relatedProjectId == row.relatedProjectId)
						include = true
				}

				return include
			})

			if (vm.filters.mainTypes.indexOf('service') == -1) {
				//service events are turned off, collapse any user/equipment service events that are duplicated
				let userIdsShowing = []
				filtered = filtered.filter(row => {
					if (row.type == 'user' && "relatedServiceId" in row && row.relatedServiceId && userIdsShowing.indexOf(row.entity_id) !== -1)
						return false
					else {
						userIdsShowing.push(row.entity_id)
						return true
					}
				})

			}
			if (vm.filters.mainTypes.indexOf("project") == -1) {
				//project events are turned off, collapse any user/equipment project events that are duplicated
				let userIdsShowing = []
				filtered = filtered.filter(row => {
					if (row.type == 'user' && "relatedProjectId" in row && row.relatedProjectId && userIdsShowing.indexOf(row.entity_id) !== -1)
						return false
					else {
						userIdsShowing.push(row.entity_id)
						return true
					}
				})
			}

			//don't love doing this here, but can't think of a better way
			
			//this.activeRowIndex = filtered.findIndex(row => row.rowId == vm.activeRowId)

			return filtered
		},
		mergeScheduleRows(rows) {
			//merge rows of same entity togeth
			let merged = []
			rows.forEach(row => {
				let foundMergedIndex = merged.findIndex(mergedRow => mergedRow.entityKey == row.entityKey && mergedRow.entity_id == row.entity_id)
			
				if (foundMergedIndex >= 0) {
					row.items.forEach(item => {
						let alreadyExists = merged[foundMergedIndex].items.find(mergedItem => mergedItem.startMoment.isSame(item.startMoment) && mergedItem.endMoment.isSame(item.endMoment))
						if (!alreadyExists)
							merged[foundMergedIndex].items.push(item)
					})
				}
				else
					merged.push(row)
			})

			return merged
		},
		shortenDescription(description,duration) {
			let maxLength = duration * 16
			if (description && description.length > maxLength)
				return description.substring(0,maxLength)+"&#8230;"

			return description
		},
		saveEvent(payload) {
			let vm = this

			vm.conflictResolutionModal.message = ""
			vm.conflictResolutionModal.newEventPayload = null
			vm.conflictResolutionModal.conflictEvent = null

			this.spinner(true)

			return new Promise((resolve,reject) => {
				vm.postData("ScheduleEvent/save",payload,true).then(response => {
					vm.spinner(false)

					if (response.success)
						vm.alertSaved("Event saved")
					else if ("errorType" in response && response.errorType == 'conflict') {
						vm.conflictResolutionModal.visible = true
						vm.conflictResolutionModal.message = response.errors[0]
						vm.conflictResolutionModal.newEventPayload = payload
						vm.conflictResolutionModal.conflictEvent = response.conflictEvent
					}
					else
						vm.alertErrors(response.errors)

					resolve(response)
				})
			})
		},
		confirmDuplicateEvent() {
			let vm = this

			this.duplicateConfirmModal.working = true
			
			let promises = []

			this.duplicateConfirmModal.relatedJobEvents.forEach(jobEvent => {

				let payload = {}

				let keysToCopy = ["user_id","equipment_id","job_id","service_id"]
				keysToCopy.forEach(key => {
					if (key in vm.duplicateConfirmModal.eventPayload)
						payload[key] = vm.duplicateConfirmModal.eventPayload[key]
				})

				//keep time, change date
				let jobStartTime = vm.moment(jobEvent.start_time)
				let eventStartTime = vm.moment(vm.duplicateConfirmModal.eventPayload.start_time)
				payload.start_time = jobStartTime.format("YYYY-MM-DD") + " " + eventStartTime.format("HH:mm")

				//make sure daily start time is not before the parent's start time. This may occur if the start time between the source parent event differs from the duplicated event
				if (vm.moment(payload.start_time).isBefore(vm.moment(jobEvent.start_time)))
					payload.start_time = jobEvent.start_time

				let jobEndTime = vm.moment(jobEvent.end_time)
				let eventEndTime = vm.moment(vm.duplicateConfirmModal.eventPayload.end_time)
				payload.end_time = jobEndTime.format("YYYY-MM-DD") + " " + eventEndTime.format("HH:mm")

				//do the same for end time -- constrain to parent event end time
				if (vm.moment(payload.end_time).isAfter(vm.moment(jobEvent.end_time)))
					payload.end_time = jobEvent.end_time

				payload.parent_event_id = jobEvent.id

				if (payload.start_time != vm.duplicateConfirmModal.eventPayload.start_time)
					//make sure we're not creating a duplicate
					promises.push(vm.postData("ScheduleEvent/save",payload))
			})

			Promise.all(promises).then(response => {
				vm.duplicateConfirmModal.visible = false
				vm.duplicateConfirmModal.working = false
				if ("childEventModal" in vm)
					vm.childEventModal.visible = false
				if ("fetchScheduleEvents" in vm)
					vm.fetchScheduleEvents()
				vm.closeDuplicateConfirmModal()
			})
		},
		closeDuplicateConfirmModal() {
			this.duplicateConfirmModal.visible = false

			if ("childEventModal" in this)
				this.childEventModal.visible = false

			setTimeout(() => {
				this.$emit('closeModal')
			},1000)
			this.$emit('closeModal')
		},
		fetchRelatedJobEvents(key,job_id,futureOnly) {
			let vm = this

			let params = {
				filters: [
					[key,job_id],
					["user_id",0],
					["equipment_id",0],
					["is_published",0]
				]
			}

			if (futureOnly && this.selectedDate)
				params.filters.push(["start_time >",this.selectedDate])

			return new Promise((resolve,reject) => {
				vm.getJSON("ScheduleEvent/get",params).then(response => {
					resolve(response)
				})
			})
		},
	}
}